import ApplicationSerializer from 'volta/_pods/application/serializer';


export default class ForecastProjectTaskSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string) {
    if (key === 'tasks') {
      return 'forecast-project-task';
    }
    return super.modelNameFromPayloadKey(key);
  }
}
